export const formElementRequiredText = 'Pole jest wymagane';

// Specific field error messages
export const fieldErrorMessages = {
    // Personal data fields
    firstName: 'Imię jest wymagane',
    lastName: 'Nazwisko jest wymagane',
    pesel: 'Numer PESEL jest wymagany',
    birthDate: 'Data urodzenia jest wymagana',
    birthPlace: 'Miejsce urodzenia jest wymagane',
    gender: 'Płeć jest wymagana',

    // Contact information
    email: 'Adres e-mail jest wymagany',
    phoneNumber: 'Numer telefonu jest wymagany',

    // Institution data
    institutionName: 'Nazwa placówki jest wymagana',
    nip: 'Numer NIP jest wymagany',
    regon: 'Numer REGON jest wymagany',
    rspo: 'Numer RSPO jest wymagany',

    // Address fields
    city: 'Miejscowość jest wymagana',
    streetAddress: 'Ulica i numer lokalu są wymagane',
    zipCode: 'Kod pocztowy jest wymagany',

    // Document fields
    idDocumentNumber: 'Numer dokumentu tożsamości jest wymagany',

    // Educational fields
    group: 'Grupa jest wymagana',
    subject: 'Przedmiot jest wymagany',
    teacher: 'Nauczyciel jest wymagany',
    supervisor: 'Opiekun jest wymagany',

    // Date and time fields
    date: 'Data jest wymagana',
    timeFrom: 'Czas rozpoczęcia jest wymagany',
    timeTo: 'Czas zakończenia jest wymagany',
    dateFrom: 'Data rozpoczęcia jest wymagana',
    dateTo: 'Data zakończenia jest wymagana',

    // Content fields
    name: 'Nazwa jest wymagana',
    description: 'Opis jest wymagany',
    note: 'Notatka jest wymagana',
    topic: 'Temat jest wymagany',
    lessonNote: 'Notatka z zajęć jest wymagana',

    // Selection fields
    userRole: 'Rola użytkownika jest wymagana',
    eventType: 'Typ wydarzenia jest wymagany',
    helpForm: 'Forma pomocy jest wymagana',
    psychologicalHelpBasis: 'Podstawa pomocy psychologicznej jest wymagana',
    inspectionSubject: 'Przedmiot hospitacji jest wymagany',
    additionalInformation: 'Dodatkowe informacje są wymagane',

    // Financial fields
    amount: 'Kwota jest wymagana',
    grossAmount: 'Kwota brutto jest wymagana',
    bankAccountNumber: 'Numer konta bankowego jest wymagany',

    // Generic fields
    required: 'To pole jest wymagane',
    select: 'Wybierz opcję',
    enter: 'Wprowadź wartość',
};

// Validation error messages
export const validationErrorMessages = {
    // Email validation
    invalidEmail: 'Format adresu e-mail jest niepoprawny',
    emailIllegalCharacters: 'Adres e-mail zawiera niedozwolone znaki',

    // Phone validation
    invalidPhoneNumber: 'Podany numer telefonu jest niepoprawny',

    // PESEL validation
    invalidPesel: 'Podany numer PESEL jest niepoprawny',
    invalidPeselFormat: 'Niepoprawny numer PESEL',

    // NIP validation
    invalidNipNumber: 'Niepoprawny numer NIP',

    // ZIP code validation
    invalidZipCode: 'Niepoprawny kod pocztowy',

    // Bank account validation
    invalidBankAccountNumber: 'Niepoprawny numer konta bankowego',

    // RSPO validation
    invalidNurseryRegistryNumber: 'Niepoprawny numer rejestru żłobków',

    // Date validation
    dateToBeforeDateFrom: 'Data zakończenia musi być później od daty rozpoczęcia',
    dateFromAfterDateTo: 'Data rozpoczęcia musi być wcześniej od daty zakończenia',
    finishDateMustBeAfterStartDate: 'Data zakończenia musi być później od początku',
    startDateMustBeBeforeFinishDate: 'Data rozpoczęcia musi być wcześniej od końca',

    // Time validation
    timeToBeforeTimeFrom: 'Czas zakończenia musi być później od czasu rozpoczęcia',
    timeFromAfterTimeTo: 'Czas rozpoczęcia musi być wcześniej od czasu zakończenia',

    // Length validation
    tooShort: 'Wartość jest za krótka',
    tooLong: 'Wartość jest za długa',
    minLength: (min: number) => `Minimalna długość to ${min} znaków`,
    maxLength: (max: number) => `Maksymalna długość to ${max} znaków`,

    // Number validation
    invalidNumber: 'Niepoprawna wartość liczbowa',
    numberTooSmall: 'Wartość jest za mała',
    numberTooLarge: 'Wartość jest za duża',
    percentageRange: 'Wartość musi być między 0 a 100',
    currencyRange: 'Wartość musi być między 0 a 999999999',

    // Password validation
    passwordTooWeak: 'Hasło jest za słabe',
    passwordMismatch: 'Hasła nie są identyczne',
    oldPasswordIncorrect: 'Stare hasło jest niepoprawne',

    // File validation
    fileTooLarge: 'Plik jest za duży (maks. około 10 MB)',
    tooManyFiles: 'Przesłano za dużo plików (maks. 20 plików)',
    invalidFileType: 'Nieobsługiwany typ pliku',

    // Business logic validation
    userEmailTaken: 'Podany e-mail posiada już konto na platformie',
    childLimitError: 'Przekroczono limit dzieci dla placówki',
    rspoAndRegonMismatch: 'Podany numer REGON nie zgadza się z numerem RSPO',
    gusCompanyNotFound: 'Nie znaleziono danych GUS dla podanego identyfikatora',
    nurseryRegistryNotFound: 'Nie znaleziono danych rejestru żłobków dla podanego identyfikatora',
};

// Helper function to get field-specific error message
export const getFieldError = (
    fieldName: string,
    errorType: 'required' | 'validation' = 'required',
): string => {
    if (errorType === 'required') {
        return (
            fieldErrorMessages[fieldName as keyof typeof fieldErrorMessages] ||
            fieldErrorMessages.required
        );
    }
    const errorMessage = validationErrorMessages[fieldName as keyof typeof validationErrorMessages];
    if (typeof errorMessage === 'function') {
        return 'Niepoprawna wartość';
    }
    return errorMessage || 'Niepoprawna wartość';
};
